import styled from 'styled-components'

export const GotItBtnContainer = styled.div`
  margin: 0 auto 40px;
`
export const WrapperForCloseBtn = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
`

export const LanguageHintModalHeader = styled.div`
  padding: 16px;
  text-align: right;
`

export const LanguageHintModalHeaderBtn = styled.button`
  background: none;
`
